//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

//token
export const LOGIN_STATUS = 'LOGIN_STATUS_TOKEN';
// uid
export const UID = 'UID';
//用户信息
export const USER_INFO = 'USER_INFO';
//token 过期时间
export const EXPIRES_TIME = 'EXPIRES_TIME';
//token 有效期(秒)，与服务端 TOKEN_EXPRESS_MINUTES(30天) 保持一致
export const TOKEN_EXPIRES_SECONDS = 30 * 24 * 60 * 60;
//微信授权
export const WX_AUTH = 'WX_AUTH';
//微信授权状态
export const STATE_KEY = 'wx_authorize_state';
//登录类型
export const LOGINTYPE = 'loginType';
//登录回调地址
export const BACK_URL = 'login_back_url';
// 小程序授权状态
export const STATE_R_KEY = 'roution_authorize_state';
//logo Url
export const LOGO_URL = 'LOGO_URL';
//模板缓存
// export const SUBSCRIBE_MESSAGE = 'SUBSCRIBE_MESSAGE';

export const TIPS_KEY = 'TIPS_KEY';

export const SPREAD = 'SPREAD';
//缓存经度
export const CACHE_LONGITUDE = 'LONGITUDE';
//缓存纬度
export const CACHE_LATITUDE = 'LATITUDE';
//app手机信息
export const PLATFORM = 'systemPlatform';
export const BOTTOM_NAVIGATION_ISCUSTOM = 'bottomNavigationIsCustom';
